export default __webpack_public_path__ + "static/es-638f61173221038847b01c4d48dcba66.svg";